<template>
  <div>
    <b-card title="مدیر جدید">
      <b-card-text>
        <div>
          <b-alert variant="danger" :show="errors.length > 0">
            <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-form @submit="onSubmit" v-if="show">
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-2"
                  label="نام و نام خانوادگی:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.name"
                    required
                    placeholder="نام و نام خانوادگی را وارد کنید"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-7"
                  label="کد ملی:"
                  label-for="input-7"
                >
                  <b-form-input
                    id="input-7"
                    v-model="form.national_card_number"
                    required
                    placeholder="کد ملی"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-1"
                  label="پست الکترونیکی:"
                  label-for="input-1"
                  description="پست الکترونیکی برای ورود به عنوان نام کاربری استفاده می شود"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.email"
                    type="email"
                    required
                    placeholder="پست الکترونیکی را وارد کنید"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-3"
                  label="نقش:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.role_id"
                    :options="roles"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-2"
                  label="رمز عبور:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    type="password"
                    v-model="form.password"
                    required
                    placeholder="رمز عبور را وارد کنید"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col></b-col>
            </b-row>

            <b-button class="mt-3" type="submit" variant="primary"
              >ذخیره</b-button
            >
            <b-button class="mt-3 ml-3" href="#/users" variant="danger"
              >بازگشت</b-button
            >
          </b-form>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";

export default {
  name: "addUser",
  data() {
    return {
      form: {
        email: "",
        name: "",
        role_id: 0,
        password: "",
        national_card_number: "",
        fa_name: " ",
        fa_family: " ",
        en_name: " ",
        en_family: " ",
        address: " ",
      },
      roles: [],
      show: true,
      errors: [],
    };
  },
  created() {
    httpHelpoer.setAuth();
    httpHelpoer
      .getData("role")
      .then((res) => {
        this.roles = res.result.map((element) => {
          return {
            value: element.id,
            text: element.name,
          };
        });
      })
      .finally(() => {});
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      httpHelper.setAuth();
      httpHelper.postData("users", this.form).then((res) => {
        if (res.success && res.result !== null) {
          this.$router.push("users");
        } else {
          if (res.error) {
            for (var key in res.error) {
              console.log(key);
              this.errors.push(res.error[key][0]);
            }
          }
        }
      });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیران",
        route: "/users",
      },
      {
        title: "مدیر جدید",
      },
    ]);
  },
};
</script>
